import Fetch from 'fetch';
import defaultBranding from './defaultModernBranding.json';

/** Query param for nxg-ui BFF branding APIs: `.../default-brandings?type=legacy` */
export const LEGACY_BRANDING_API_TYPE = 'legacy';

export default {
    getModernBranding(diId, isAuthenticated) {
        const { pathname } = window.location;
        let region = 'live';

        if (pathname.indexOf('/beta/') !== -1) {
            region = 'beta';
        }

        const url = isAuthenticated
            ? `/nxg-olb-bff/${region}/nxg-ui/v1/brandings`
            : `/nxg-olb-bff/${region}/nxg-ui/v1/default-brandings`;

        const clearBrandingSession = () => {
            sessionStorage.removeItem('modernBrandingJSON');
            sessionStorage.removeItem('modernLogos');
        };

        return Fetch.get(
            url,
            { type: LEGACY_BRANDING_API_TYPE },
            { institutionId: diId },
        )
            .then((data) => {
                if (!data) {
                    clearBrandingSession();

                    // eslint-disable-next-line no-null/no-null
                    return null;
                }

                if (
                    typeof data === 'object' &&
                    !Array.isArray(data) &&
                    Object.keys(data).length === 0
                ) {
                    clearBrandingSession();

                    // eslint-disable-next-line no-null/no-null
                    return null;
                }

                if (typeof data === 'string' && data.trim() === '') {
                    clearBrandingSession();

                    // eslint-disable-next-line no-null/no-null
                    return null;
                }

                const theme = data.themes?.light;

                if (
                    !theme ||
                    typeof theme !== 'object' ||
                    Array.isArray(theme)
                ) {
                    clearBrandingSession();

                    // eslint-disable-next-line no-null/no-null
                    return null;
                }

                // Store logos only when present; JSON.stringify(undefined) is
                // undefined, and setItem coerces that to the string "undefined",
                // which later JSON.parse calls cannot parse.
                if (
                    data.logos &&
                    typeof data.logos === 'object' &&
                    !Array.isArray(data.logos)
                ) {
                    sessionStorage.setItem(
                        'modernLogos',
                        JSON.stringify(data.logos),
                    );
                } else {
                    sessionStorage.removeItem('modernLogos');
                }

                return theme;
            })
            .catch((err) => {
                // eslint-disable-next-line no-console -- log branding fetch failures for debugging
                console.error(err);

                clearBrandingSession();

                // Empty default-brandings?type=legacy (e.g. 204) → leapfrog CSS, not /brandings theme or static JSON.
                if (isAuthenticated === false) {
                    // eslint-disable-next-line no-null/no-null
                    return null;
                }

                return defaultBranding;
            });
    },
};
